import EventBus from "@plugins/common/service/eventbus";
export const AnnotationEventBus = new EventBus();
